import TextWithClickableQuotes from '@/utils/TextWithClickableQuotes';

interface InsightCardProps {
  title: string;
  body: string;
  index?: number;
  voiceQuotes?: Array<{ conversation_id: string; message_id?: string }>;
}

function InsightCard({ title, body, index, voiceQuotes }: InsightCardProps) {
  return (
    <div className="rounded-lg border border-neutral-100 bg-neutral-50/50 p-4">
      <div className="flex gap-3">
        {index !== undefined && (
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-xs font-semibold text-emerald-700">
            {index}
          </span>
        )}
        <div className="min-w-0 flex-1">
          <h4 className="text-sm font-semibold text-neutral-800 mb-1.5">{title}</h4>
          <div className="text-[14px] leading-relaxed text-neutral-600">
            <TextWithClickableQuotes text={body} voiceQuotes={voiceQuotes} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default InsightCard;
